<template>
  <el-select
    class="jm-input280"
    v-model="tempValue"
    multiple
    clearable
    filterable
    remote
    reserve-keyword
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    @change="(v) => $emit('change', v)"
    :loading="loading">
    <el-option
      v-for="item in options"
      :key="item.sh_id"
      :label="item.sh_name_cn"
      :value="item.sh_id">
    </el-option>
  </el-select>
</template>

<script>

export default {
  name: 'SchoolMultipleSearch',
  props: {
    countryId: {
      type: [Number, String],
      default: null,
    },
    countryShId: {
      type: [Number, String],
      default: null,
    },
    countryShMgId: {
      type: [Number, String],
      default: null,
    },
    value: [Object, String, Array],
    placeholder: {
      type: String,
      default: '请输入学校',
    },
    defaultOptions: {
      type: Array,
      default: () => []
    }
  },
  model: {
    event: 'change',
  },
  data() {
    return {
      options: [],
      loading: false,
      tempValue: ''
    };
  },
  mounted() {

  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.$http
            ._post({
              url: '/index/api_base/searchSchool',
              data: {
                countryId: this.countryId, // cms中的国家id
                countryShId: this.countryShId, // 院校国家id
                countryShMgId: this.countryShMgId, // 院校国家细分id
                name: query
              }
            })
            .then((res) => {
              this.options = res.data;
            });
          this.loading = false;
        }, 200);
      } else {
        this.options = [];
      }
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.tempValue = v;
      }
    },
    defaultOptions(v) {
      if (v) {
        this.options = v;
      }
    }
  },
};
</script>
